import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

import IntentBanner from "../IntentBanner/IntentBanner";

import { StyledButtonWrapper } from "./styles";

type Props = {
    className?: string;
    title?: ReactNode;
    description?: ReactNode;
};

const BaseIntentEmptyTopicsBanner = ({ title, description, className }: Props) => {
    const onSelectedTopicsClicks = () => {
        trackingService.trackIntentSelectTopics();
        void siNavigator.goToIntentSignalsManagementPage();
    };

    return (
        <IntentBanner
            className={className}
            icon={
                <SWReactIcons
                    iconName="fire-colored"
                    size="sm"
                />
            }
            title={title}
            description={description}
            isVerticalView
        >
            <StyledButtonWrapper>
                <IconButton
                    type="primary"
                    iconName="arrow-right"
                    placement="right"
                    onClick={onSelectedTopicsClicks}
                >
                    {translate("si.signals.buttons.selectTopics.name")}
                </IconButton>
            </StyledButtonWrapper>
        </IntentBanner>
    );
};

export default BaseIntentEmptyTopicsBanner;
